<template>
  <div>
    <div class="LkMunMehReviewForm__content">
      <router-link class="LkMunMehReviewForm__content__link" :to="getListLink()">
        <v-row>
          <v-col cols="8">
            <h3
              class="LkMunMehReviewForm__title"
              v-text="munMeh.name"
            />
          </v-col>
          <v-col cols="4">
            <v-row>
              <v-col v-if="!isSecondLevelExpert" :cols="9" />
              <v-col v-else :cols="3" />

              <template v-if="isSecondLevelExpert">
                <v-col cols="3" class="text-right">
                  <div
                    class="LkMunMehReviewForm__title bold"
                    style="display: inline-block;"
                    v-text="getSumForExpertOne"
                  />
                </v-col>
                <v-col cols="3" class="text-right">
                  <div
                    class="LkMunMehReviewForm__title bold"
                    style="display: inline-block;"
                    v-text="getSumForExpertTwo"
                  />
                </v-col>
              </template>
              <v-col cols="3" class="text-right">
                <div
                  class="LkMunMehReviewForm__title bold"
                  v-text="getOwnerSum"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </router-link>

      <hr class="LkMunMehReviewForm__line">

      <template v-if="!activeForm">
        <p>Форма не загружена. Возможно такой формы не существует.</p>
      </template>
      <template v-else>
        <v-row>
          <v-col :cols="isSecondLevelExpert ? 6 : 8">
            <h4
              class="LkMunMehReviewForm__content__title__header mx-0"
              v-text="'Позиция оценивания'"
            />
          </v-col>
          <v-col :cols="isSecondLevelExpert ? 6 : 4">
            <v-layout row align-center justify-end>
              <v-spacer />
              <h4
                class="LkMunMehReviewForm__content__title__header"
                v-text="isSecondLevelExpert ? 'Макс. балл' : 'Максимальный балл'"
              />
              <template v-if="isSecondLevelExpert">
                <h4
                  class="LkMunMehReviewForm__content__title__header"
                  v-text="'Эксперт 1'"
                />
                <h4
                  class="LkMunMehReviewForm__content__title__header"
                  v-text="'Эксперт 2'"
                />
              </template>
              <h4
                class="LkMunMehReviewForm__content__title__header"
                v-text="'Ваша оценка'"
              />
            </v-layout>
          </v-col>
        </v-row>

        <template v-if="isGeneral">
          <ReviewLink
            v-for="(item, idx) in activeForm.data"
            :key="item.id"
            :get-link-builder="getLevelLinkBuilder"
            :idx="idx"
            :item="item"
            :second-level="isSecondLevelExpert"
            bold
            class="LkMunMehReviewForm__content__link"
          />
        </template>
        <template v-else>
          <ReviewLink
            v-for="(link, index) in openedLinks"
            :key="`Opened.${link.index}`"
            :get-link-builder="getLevelLinkBuilder"
            :idx="link.index"
            :item="link.level"
            :bold="index === 0"
            :second-level="isSecondLevelExpert"
            class="LkMunMehReviewForm__content__link"
          />

          <template v-if="levelDescription">
            <hr class="LkMunMehReviewForm__line">

            <div class="LkMunMehReviewForm__content__level-description" v-text="levelDescription" />
          </template>

          <template v-if="hasParameters">
            <hr class="LkMunMehReviewForm__line">

            <LKMunMehReviewFourLevels
              ref="FourLevels"
              :key="currentLevel.id"
              :mun-meh-id="munMeh.id"
              :parent="currentLevel"
              :disabled="isLoadingAsyncData || viewOnly"
              :parent-idx="latestIndex"
              :second-level="isSecondLevelExpert"
            />
          </template>
        </template>
      </template>
    </div>

    <template v-if="activeForm">
      <template v-if="!isGeneral && !hasParameters">
        <div class="LkMunMehReviewForm__content">
          <ReviewLink
            v-for="(item, idx) in currentLevel.items"
            :key="item.id"
            :get-link-builder="getLevelLinkBuilder"
            :idx="idx"
            :item="item"
            :second-level="isSecondLevelExpert"
            :read-only="viewOnly"
            class="LkMunMehReviewForm__content__link"
          />
        </div>
      </template>

      <LKMunMehReviewFooter
        v-if="hasParameters"
        :loading="isLoadingAsyncData"
        :read-only="viewOnly"
        @save="onSaveMarks"
        @next="goToNext"
        @main="onGoToForm"
        @prev="goToPrev"
      />
    </template>
  </div>
</template>

<script>
import LKMunMehReviewFooter from '@/views/LKMunMeh/Review/components/LKMunMehReviewFooter.vue'
import LKMunMehReviewFourLevels from '@/views/LKMunMeh/Review/components/LKMunMehReviewFourLevels.vue'

const ReviewLink = () => import(
  /* webpackChunkName: "LKMunMehReviewReviewLink" */
  '@/views/LKMunMeh/Review/components/LKMunMehReviewLink.vue'
)

import MunMehLevelMixin from '@/views/LKMunMeh/mixins/MunMehLevelMixin'
import { lkMapper } from '@/store/modules/lk'
import { LKMunMehReviewMapper as StoreMapper } from '@/views/LKMunMeh/Review/store'
import { BASE_DELIMITER_URL, MAX_SEARCH_DEPTH } from '@/views/LKMunMeh/utils'
import { LK_MUN_MEH_FORM_REVIEW_ROUTES as ROUTES } from '@/views/LKMunMeh/Review/utils'

export default {
  name: 'LKMunMehReviewFormContent',
  formRoute: ROUTES.FORM,
  anyLevelRoute: ROUTES.ANY_LEVEL,
  components: {
    ReviewLink,
    LKMunMehReviewFooter,
    LKMunMehReviewFourLevels,
  },
  mixins: [MunMehLevelMixin],
  props: {
    form: {
      type: Object,
      required: true,
    },
    formId: Number,
  },
  computed: {
    ...lkMapper.mapGetters(['profile']),
    ...StoreMapper.mapState(['values']),
    ...StoreMapper.mapGetters(['getMarkForLevel', 'getMarkForExpertOneLevel', 'getMarkForExpertTwoLevel']),
    activeForm() {
      return this.form
    },
    isSecondLevelExpert() {
      return this.profile.id === this.activeForm?.second_level_expert_id
    },
    getSumForExpertOne() {
      if (!this.isSecondLevelExpert || !this.activeForm || !this.activeForm.data) {
        return 0
      }

      return this.activeForm.data.reduce((acc, cur) => acc + this.getMarkForExpertOneLevel(cur.id), 0)
    },
    getSumForExpertTwo() {
      if (!this.isSecondLevelExpert || !this.activeForm || !this.activeForm.data) {
        return 0
      }

      return this.activeForm.data.reduce((acc, cur) => acc + this.getMarkForExpertTwoLevel(cur.id), 0)
    },
    getOwnerSum() {
      if (!this.activeForm || !this.activeForm.data) {
        return 0
      }

      return this.activeForm.data.reduce((acc, cur) => acc + this.getMarkForLevel(cur.id), 0)
    },
  },
  watch: {
    hasParameters: {
      async handler(v) {
        if (!v) return
        await this.onGetLevelData()
      },
      immediate: true,
    },
    formId: {
      async handler(v) {
        if (!v) return
        await this.onGetForm(v)
      },
      immediate: true,
    },
  },
  methods: {
    ...StoreMapper.mapMutations(['addIndicatorValue']),
    ...StoreMapper.mapActions([
      'getLevelMarks',
      'getLevelData',
      'saveLevelMarks',
      'validateFormMarks',
    ]),
    async onGetLevelData() {
      const { params } = this.$route
      const { munMehId, formId } = params
      const { currentLevel } = this
      await this.getLevelData({ munMehId, formId, parentLevel: currentLevel })

      // this.updateValues(this.values)
      if (this.$refs.FourLevels) {
        this.$refs.FourLevels.onSaved()
      }
    },
    async onSaveMarks() {
      if (this.viewOnly) return true

      const result = await this.$refs.FourLevels.validate()
      if (!result) {
        this.$notice.warning('Ошибки валидации в форме')
        return false
      }

      this.isLoadingAsyncData = true
      try {
        const { currentLevel, $route } = this
        const { params } = $route
        const { formId, munMehId } = params
        await this.saveLevelMarks({ munMehId, formId, parentLevel: currentLevel })
        this.$notice.create('Данные сохранены')

        // Обновление оценок вышестоящих уровней
        const oldMarksSumForCurrentLevel = this.getMarkForLevel(currentLevel.id)
        const marksSumForCurrentLevel = currentLevel.items.reduce(
          (acc, level) => acc + this.getMarkForLevel(level.id), 0,
        )
        const delta = marksSumForCurrentLevel - oldMarksSumForCurrentLevel
        this.updateTreeMarks(currentLevel, delta)

        this.$refs.FourLevels.onSaved()
      } catch (e) {
        this.$notice.errors(e)
      }
      this.isLoadingAsyncData = false
      return true
    },
    /**
     * Обновление оценок вышестоящих уровней при сохранении
     * @param level Уровень, который подвергается изменению.
     * @param delta Дельта
     */
    updateTreeMarks(level, delta = 0) {
      if (delta === 0 || !level) {
        return
      }

      const levelMark = this.getMarkForLevel(level.id)
      this.addIndicatorValue({
        value: levelMark + delta,
        indicator_id: level.id,
        indicator_value_id: null,
        name: '',
        max_score: 0,
      })

      const parent = this.hierarchyLevels.find((el) => el.id === level.parent_id)
      if (parent) this.updateTreeMarks(parent, delta)
    },
    async goToNext() {
      if (!await this.onSaveMarks()) return

      const targetUrl = this.findNextLevel(this.currentLevel, this.levels.length - 1)
      if (targetUrl) {
        await this.$router.push(targetUrl)
        await this.onGetLevelData()
        return
      }

      this.onGoToForm()
    },
    async goToPrev() {
      if (!await this.onSaveMarks()) return

      const targetUrl = this.findPrevLevel(this.currentLevel, this.levels.length - 1)
      if (targetUrl) {
        await this.$router.push(targetUrl)
        await this.onGetLevelData()
        return
      }

      this.onGoToForm()
    },
    async goToFill() {
      const nonFilledLevels = await this.validateFormMarks(this.formId)
      if (nonFilledLevels?.length > 0) {
        await this.goToMissed(nonFilledLevels)
        return
      }

      this.$notice.info('Форма заполнена. Нажмите кнопку "сдать отчёт" для отправки данных.')
      const { params } = this.$route
      const { munMehId, formId } = params
      await this.$router.push({
        name: this.$options.formRoute,
        params: { munMehId, formId },
      })
    },
    async goToMissed(nonFilledLevels) {
      const { activeForm } = this
      const { indicator_id } = nonFilledLevels.pop()
      const targetUrl = await this.findLevelToFill(activeForm, [], 1, indicator_id)
      if (targetUrl) {
        await this.$router.push(targetUrl)
      }
    },
    findLevelToFill(level, levelIds, depth, searchedLevelId) {
      if (depth > MAX_SEARCH_DEPTH || !level) {
        return null
      }

      if (level.id === searchedLevelId) {
        levelIds.pop()
        return {
          name: this.$options.anyLevelRoute,
          params: {
            levels: levelIds.join(BASE_DELIMITER_URL),
            viewType: this.viewType,
            savePosition: true,
          },
        }
      }

      const items = level.data || level.items || []
      // eslint-disable-next-line no-restricted-syntax
      for (const child of items) {
        const result = this.findLevelToFill(child, levelIds.concat(child.id), depth + 1, searchedLevelId)
        if (result) {
          return result
        }
      }
      return null
    },
  },
}
</script>
